/**
 * Where this article is, and every step you can go back to.
 *
 * The four screens were a one-way corridor: forward through 条件 → 構成 → 本文 →
 * 仕上げ, and the only way back was the browser button or the article list. So an
 * article saved half way through looked, on return, like an empty editor.
 *
 * Every step is a link, always, in both directions. Going back to 構成 after the
 * body exists is a normal thing to want - the writer noticed a heading is wrong -
 * and nothing is lost by it: the outline and the drafted sections are stored, and
 * the body is only replaced when somebody presses save.
 */
import { Link } from 'react-router';
import { STAGES, type Stage } from '../stage.ts';

export function StageBar({ articleId, current }: { articleId: string; current: Stage }) {
  const at = STAGES.findIndex((step) => step.id === current);

  return (
    <nav className="stagebar" aria-label="記事作成の進行">
      <ol className="stagebar__list">
        {STAGES.map((step, index) => {
          const state = index === at ? 'current' : index < at ? 'done' : 'ahead';
          return (
            <li key={step.id} className={`stagebar__step stagebar__step--${state}`}>
              <Link
                to={step.path(articleId)}
                {...(index === at ? { 'aria-current': 'step' as const } : {})}
              >
                <span className="stagebar__no" aria-hidden>
                  {index + 1}
                </span>
                {step.label}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
